import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Button from 'screens/components/basic/Button';
import LOOKUP from 'constants/lookup';
import AddressInfo from 'screens/components/advanced/AddressInfo';
import TextInput from 'screens/components/basic/TextInput';
import MaskedTextInput from 'screens/components/advanced/MaskedTextInput';
import ToggleInput from 'screens/components/basic/ToggleInput';
import { selectDoctorModel } from 'selectors/entitySelector';
import { initializeDoctorForm, loadDoctorForm } from 'actions/FormActions';
import { saveDoctor } from 'actions/EntityActions';
import { showError, showSnackbar } from 'actions/CommonActions';
import util from 'library/util';
import Grid from 'screens/components/basic/Grid';
import { doctorAddCrumb, doctorEditCrumb } from 'utils/breadcrumbInfo';
//import SearchFields from './searchFields';

//component for save the Doctors
class DoctorSave extends Component {
    constructor(props, context) {
        super(props, context);

        //bind this to the functions
        this.saveDoctor = this.saveDoctor.bind(this);
        this.cancel = this.cancel.bind(this);
        //set initial state (ADD or EDIT)
        this.state = {
            status: ""
        };
    }



    //check if we have doctorId in the URL
    componentWillMount() {
        const doctorId = this.props.params.id;
        //if true dispatch an action to retrive doctor data from API and set Status to EDIT
        if (doctorId) {
            this.setState({ status: "EDIT" });
            this.props.getDoctor(doctorId, this.props.branchId);
        }
        //if false dispatch an action to clean the form and set default values, Status to ADD
        else {
            this.setState({ status: "ADD" });
            this.props.init(this.props.name);
        }
    }

    //check if the Save Success or SaveError happened
    componentWillReceiveProps(newProps) {
        if ((newProps.saveSuccess != null && newProps.saveSuccess !== this.props.saveSuccess)
            || (newProps.saveError != null && newProps.saveError !== this.props.saveError)) {
            //if does changed call the respective action (SUCCESS OR FAILURE)
            if (newProps.saveSuccess)
                this.saveSuccess();
            else
                this.saveFailure();
        }
    }

    //when Patient is saved successfully
    saveSuccess = () => {
        this.props.onDoctorCreated();
        this.props.showDoctorCreatedSnackbar(this.state.status === "EDIT" ? LOOKUP.doctor.editedMessage : LOOKUP.doctor.createdMessage);
    }

    //when Patient is not saved, failure
    saveFailure = () => {
        this.props.showDoctortError(LOOKUP.doctor.saveErrorMessage);
    }

    //call API to save the doctor
    saveDoctor = () => {
        const p = this.props;
        let doctor = this.props.doctorModel;
        //let doctorId = doctor.Id;

        const validators = [
            [p.name + 'FirstName', doctor => (doctor.FirstName && doctor.FirstName !== null && doctor.FirstName !== ""), "First Name"],
            [p.name + 'LastName', doctor => (doctor.LastName && doctor.LastName !== null && doctor.LastName !== ""), 'Last Name']
            // [p.name + 'License', doctor => (doctor.License && doctor.License !== null && doctor.License !== ""), "License"],
            // [p.name + 'Clinic', doctor => (doctor.Clinic && doctor.Clinic !== null && doctor.Clinic !== ""), "Clinic"],
            // [p.name + 'Phone', doctor => (doctor.Phone && doctor.Phone !== null && doctor.Phone !== ""), "Phone"],
            // [p.name + 'Address', doctor => (doctor.Address && doctor.Address !== null && doctor.Address !== ""), "Address"],
            // [p.name + 'Country', doctor => (doctor.Country && doctor.Country !== null && doctor.Country !== ""), "Country"],
            // [p.name + 'ProvinceState', doctor => (doctor.State && doctor.State !== null && doctor.State !== ""), "Province"],
            // [p.name + 'City', doctor => (doctor.City && doctor.City !== null && doctor.City !== ""), "City"],
            // [p.name + 'PostalCode', doctor => (doctor.Zip && doctor.Zip !== null && doctor.Zip !== ""), "Postal Code"] //Needs to change the name of property
        ];

        if (util.validate(validators, doctor, this.props.formError)) {
            this.props.saveDoctor(doctor);
        }
    }
    //cancel the Save form, call the parent cancel function (redirect to listing)
    cancel = () => {
        this.props.cancel();
    };

    render() {
        const p = this.props;
        const title = this.state.status === 'ADD' ? LOOKUP.doctor.titles.add : LOOKUP.doctor.titles.edit;
        const breadCrumbPage = this.state.status === 'EDIT' ? doctorEditCrumb : doctorAddCrumb
        /*
            Missing fields:
                - Office Phone (now we have just one phone) (growone mmj)
                - Website (mmj)
                - License Expiration (mmj)
                - Degree (mmj)
        */
        const header = (
            <div>
                <ol className="breadcrumb">
                    <li><Link to={LOOKUP.menu.home.link}>{LOOKUP.menu.home.text}</Link></li>
                    <li><Link to={LOOKUP.menu.user.items.doctor.link}>{LOOKUP.menu.user.items.doctor.text}</Link></li>
                    <li className="active">{title}</li>
                </ol>
                <h2>{title} <Button type="HeaderBackPage" onTouchTap={() => this.props.cancel()} /></h2>
            </div>);

        return (
            <Grid headerContent={breadCrumbPage}>
                <div className="form-group editPage">
                    <div title="Profile" className="">
                        {/* LEFT PANEL */}
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 p-5 pb-0">
                            {/* General Information */}
                            <h4 className="profile-view-subtitle d-block purpleText">General Information</h4>
                            <br />
                            {(this.state.status === 'EDIT')
                                ?
                                <div className="row">
                                    <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                        <p>ID: {this.props.doctorModel.Id}</p>
                                    </div>
                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                        <ToggleInput className="patient_status btnToggleLabel" name={`${p.name}Status`} label={"Status"} />
                                    </div>
                                </div>
                                :
                                null
                            }
                            <div className="row">
                                <div className="col-lg-12">
                                    <TextInput
                                        name={p.name + "FirstName"}
                                        floatingLabelText={LOOKUP.doctor.firstname.label}
                                        label={LOOKUP.doctor.firstname.label}
                                        hintText={LOOKUP.doctor.firstname.hintText}
                                        fullWidth={true}
                                        maxLength={50}
                                        required />
                                </div>
                                <div className="col-lg-12">
                                    <TextInput
                                        name={p.name + "LastName"}
                                        floatingLabelText={LOOKUP.doctor.lastname.label}
                                        label={LOOKUP.doctor.lastname.label}
                                        hintText={LOOKUP.doctor.lastname.hintText}
                                        fullWidth={true}
                                        maxLength={50}
                                        required />
                                </div>
                                <div className="col-lg-12">
                                    <TextInput
                                        name={p.name + "License"}
                                        label={LOOKUP.doctor.license.label}
                                        floatingLabelText={LOOKUP.doctor.license.label}
                                        hintText={LOOKUP.doctor.license.hintText}
                                        fullWidth={true}
                                        maxLength={20}
                                        required />
                                </div>
                            </div>
                        </div>
                        {/* RIGHT PANEL */}
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 editInfo">
                            {/* Contact Information */}
                            <h4 className="profile-view-subtitle d-block purpleText">Contact Information</h4>
                            <br />
                            <div className="row">
                                <div className="col-lg-6">
                                    <TextInput
                                        name={p.name + "Clinic"}
                                        floatingLabelText={LOOKUP.doctor.clinic.label}
                                        label={LOOKUP.doctor.clinic.label}
                                        hintText={LOOKUP.doctor.clinic.hintText}
                                        fullWidth={true}
                                        maxLength={50}
                                        required />
                                </div>
                                <div className="col-lg-6">
                                    <MaskedTextInput
                                        fullWidth={true}
                                        name={`${p.name}Phone`}
                                        floatingLabelText={"Phone"}
                                        hintText={"Phone"}
                                        mask="(999) 999-9999" />
                                    {/* <MaskInput
                                        name={p.name + "Phone"}
                                        floatingLabelText="Phone"
                                        mask="(###)___-####"
                                        useUnmaskedValue fullWidth={true} /> */}
                                </div>
                            </div>
                            <AddressInfo name={p.name} />
                        </div>
                    </div>
                    <div className="clear-both">
                        {/* BUTTONS PANEL */}
                        <div className="btns-editPage border-top-purple">
                            <div className="">
                                <Button name="buttonSave"
                                    className="pull-right"
                                    label={LOOKUP.doctor.controls.saveButton}
                                    primary={true}
                                    onTouchTap={() => this.saveDoctor()} />
                                <Button
                                    type="CancelButton"
                                    name="buttonCancel"
                                    className="pull-right btn-space"
                                    label={LOOKUP.common.cancel.text}
                                    onTouchTap={() => this.cancel()} />
                            </div>
                        </div> {/* END - BUTTONS PANEL */}
                    </div>
                </div>
            </Grid>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        doctorModel: selectDoctorModel(state, ownProps.name),
        branchId: state.common.branchId,
        saveSuccess: state.form[ownProps.name + "SaveSuccess"],
        saveError: state.form[ownProps.name + "SaveError"]
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        init: () => dispatch(initializeDoctorForm(ownProps.name)),
        saveDoctor: (doctor) => dispatch(saveDoctor(doctor, ownProps.name)),
        getDoctor: (id, branchId) => dispatch(loadDoctorForm(id, ownProps.name, branchId)),
        formError: (name, error) => dispatch({ type: 'FORM_ERROR', name, error }),
        showDoctorCreatedSnackbar: (message) => dispatch(showSnackbar(message)),
        showDoctortError: (message) => dispatch(showError(message))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(DoctorSave); 